import { ReportItem } from "./report-item";
import { ApiText } from '../api-text';
import { Grouping } from '@classes/grouping/grouping';

export class Report {
    code?: string;
    username?: string;
    lang?: string;
    fileId?: string;

    text: ApiText;
    createdAt: Date;

    reportItems: ReportItem[];
    organismGroups?: Grouping[];
}
